<template>
  <div>
    <div class="home-container">
      <section1></section1>
      <section2></section2>
      <section3></section3>
      <section4></section4>
    </div>
  </div>
</template>

<script>
import Section1 from "../../components/SlideBlack";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
export default {
  name: "home",
  components: {
    Section1,
    Section2,
    Section3,
    Section4
  },
  metaInfo: {
    title: "Homepage"
  }
};
</script>

<style lang="scss" scoped>
@import "@scss/home/home.scss";
</style>